const cards = [
  {
    title: '海角视频热门合集',
    desc: '每周精选最受欢迎的海角视频内容，按类别整理成合集，方便用户一站式浏览。',
    icon: 'ri-video-line',
    color: 'primary',
  },
  {
    title: '社区精华帖精选',
    desc: '海角论坛优质长文和深度讨论汇总，涵盖科技、文化、生活等多个领域。',
    icon: 'ri-chat-1-line',
    color: 'accent',
  },
  {
    title: '创作者成长学院',
    desc: '海角社为创作者提供的系统化成长教程，从内容策划到粉丝运营全覆盖。',
    icon: 'ri-book-open-line',
    color: 'primary',
  },
  {
    title: '海角网址导航',
    desc: '收录海角网各核心板块入口，便捷直达海角在线各个功能区域。',
    icon: 'ri-compass-3-line',
    color: 'accent',
  },
  {
    title: '每日更新速递',
    desc: '海角网每日内容更新汇总，不错过任何精彩作品和热门话题。',
    icon: 'ri-flashlight-line',
    color: 'primary',
  },
  {
    title: '兴趣圈子广场',
    desc: '基于共同兴趣组建的专属圈子，在海角社区找到属于你的同好群体。',
    icon: 'ri-group-line',
    color: 'accent',
  },
  {
    title: '安全访问指南',
    desc: '海角官网入口安全说明，确保用户始终通过正规渠道访问海角网。',
    icon: 'ri-shield-check-line',
    color: 'primary',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            功能导航
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            快速了解海角网的核心板块与服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((card) => (
            <article
              key={card.title}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer group"
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${
                  card.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${card.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                {card.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((card) => (
            <article
              key={card.title}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer group"
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${
                  card.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${card.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                {card.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}